export default __webpack_public_path__ + "static/media/logo.24b88782.svg";